function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFingerprintBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-33"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.32,
    y: 187.39,
    width: 36.39,
    height: 26.77,
    rx: 2.38,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.99,
    y: 189.7,
    width: 16.37,
    height: 9.08,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.99,
    y: 201.53,
    width: 3.1,
    height: 1.71,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.99,
    y: 204.4,
    width: 3.1,
    height: 1.71,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.99,
    y: 207.27,
    width: 3.1,
    height: 1.71,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.99,
    y: 210.14,
    width: 3.1,
    height: 1.71,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.42,
    y: 201.53,
    width: 3.1,
    height: 1.71,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.42,
    y: 204.4,
    width: 3.1,
    height: 1.71,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.42,
    y: 207.27,
    width: 3.1,
    height: 1.71,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.42,
    y: 210.14,
    width: 3.1,
    height: 1.71,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.84,
    y: 201.53,
    width: 3.1,
    height: 1.71,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.84,
    y: 204.4,
    width: 3.1,
    height: 1.71,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.84,
    y: 207.27,
    width: 3.1,
    height: 1.71,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.84,
    y: 210.14,
    width: 3.1,
    height: 1.71,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.26,
    y: 201.53,
    width: 3.1,
    height: 1.71,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.26,
    y: 204.4,
    width: 3.1,
    height: 1.71,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.26,
    y: 207.27,
    width: 3.1,
    height: 1.71,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.26,
    y: 210.14,
    width: 3.1,
    height: 1.71,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.23,
    y: 187.39,
    width: 8.92,
    height: 24.46,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.23,
    y: 194.24,
    width: 8.92,
    height: 10.17,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "294.23 204.4 295.93 198.78 301.91 198.78 303.15 204.4 294.23 204.4",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "443.89 80.54 443.89 383 379.59 383 379.71 382.5 434.32 382.5 434.32 89.09 320.81 89.09 320.81 382.5 355.94 382.5 379.59 383 312.26 383 312.26 80.54 443.89 80.54",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "434.32 89.09 434.32 382.5 379.71 382.5 379.59 383 355.94 382.5 320.81 382.5 320.81 89.09 434.32 89.09",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.81,
    y: 89.09,
    width: 113.51,
    height: 293.42,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "434.32 89.09 434.32 168.29 379.71 382.5 379.59 383 355.94 382.5 431.72 89.09 434.32 89.09",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.81,
    y: 204.82,
    width: 13.31,
    height: 43.81,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "396.59 89.09 320.81 382.51 344.45 383 419.38 89.09 396.59 89.09",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.21,343.63a.28.28,0,0,1-.29-.28c-.88-26.06,7.06-36,7.14-36.1a.29.29,0,0,1,.45.37c-.08.09-7.88,9.9-7,35.71a.28.28,0,0,1-.28.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.92,343.63h0a.29.29,0,0,1-.26-.32c.7-7.62,3.43-13.44,8.13-17.3,7.32-6,17-5.09,17.09-5.08a.29.29,0,0,1,.26.32.29.29,0,0,1-.32.26c-.09,0-9.53-.91-16.67,4.95-4.57,3.76-7.23,9.45-7.91,16.91A.28.28,0,0,1,264.92,343.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.8,321.09c-1.41-2.84-13.11-4.78-6.41-10.94s6.67,7.05,9.65,7c4.17-.07,3.36-17.74,10.24-13.18s-6.79,11.77-4.6,15c2,3,14.15-6.7,14.42-.77s-12.93,1.54-13.78,5.11c-.65,2.79,12.36,5.32,6.59,9.36s-7.62-8.21-10.8-7.42c-2.41.6.81,10.66-4.05,9.09S285.29,324.08,283.8,321.09Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.78,346.88a.3.3,0,0,1-.29-.27C254.17,324,244,310.1,243.87,310a.3.3,0,0,1,0-.41.29.29,0,0,1,.41.06c.11.14,10.4,14.11,12.74,36.94a.29.29,0,0,1-.26.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.61,318.56c-3.53,2.94-2.36,20.06-13.27,12.69S241,319.5,240,315.32c-1.49-5.86-26.1,1.18-22-10s18.84,5.65,22.71,1.47c3.55-3.83-14.16-17.7-5.9-20.06s6.48,17.7,11.8,17.7c4.14,0,3.37-19.17,11-12.39s-9,13.47-6.85,17.68c1.66,3.2,14.75-4.7,14.16,2.68S250.32,315.48,246.61,318.56Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.18,369.13,276.57,341H242.5l2.4,28.15a14.69,14.69,0,0,0,14.64,13.45h0A14.69,14.69,0,0,0,274.18,369.13Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.93,316.2c3.53,2.94,2.36,20.06,13.27,12.69s-7.7-11.75-6.63-15.93c1.49-5.86,26.1,1.18,22-10s-18.84,5.65-22.71,1.47c-3.56-3.83,14.16-17.7,5.9-20.06s-6.48,17.7-11.8,17.7c-4.14,0-3.37-19.17-11-12.39s9,13.47,6.85,17.68c-1.66,3.2-14.75-4.7-14.16,2.68S262.22,313.12,265.93,316.2Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.9,
    y: 244,
    width: 137.65,
    height: 137.65,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.43,
    y: 254.53,
    width: 117.66,
    height: 126.87,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.52,
    y: 307.27,
    width: 3.98,
    height: 14.42,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.53,
    y: 300.57,
    width: 3.98,
    height: 28.33,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.53,
    y: 300.57,
    width: 5.96,
    height: 4.3,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.53,
    y: 324.59,
    width: 5.96,
    height: 4.3,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-33"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-33",
    cx: 250,
    cy: 415.69,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Fingerprint--inject-33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.35,115l2.48.45-2.05-1.58c-.54-.42-1.1-.84-1.65-1.24l-.13-.1-.16,0C176.17,110,160.75,105.57,143,99.2l-.15-.06-.16,0c-.59.08-1.18.18-1.76.29l-2.22.43,2.22.81C160.27,107.71,176.9,112.51,190.35,115Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.48,123.07l2,.47L200,122c-.38-.4-.77-.78-1.17-1.17l-.14-.13-.19,0c-17.68-4.2-40.06-10.36-66.49-18.29l-.24-.07-.21.09-1.15.55-1.43.71,1.62.49C158.22,112.45,181.39,118.82,199.48,123.07Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.88,132.68l2,.7-1.29-1.67c-.19-.25-.39-.49-.58-.73l-.26-.32,0-.25-.44-.16c-15.29-5.4-42.2-13.75-83.61-22.9l-.28-.06-.22.16c-.3.22-.6.43-.9.67l-1.07.84,1.41.31C165,118.62,192.4,127.16,207.88,132.68Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.62,143.82l2,1-1.21-1.9-.87-1.37-.11-.17-.18-.08c-18.41-9.28-50.48-21.64-98.73-27.88l-.3,0-.2.2-.78.78-.88.93,1.35.17C164.86,121.75,197.17,134.35,215.62,143.82Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.62,144.4h0a170.28,170.28,0,0,1,19.79,11.45l2,1.32-1.05-2.09c-.21-.42-.43-.82-.64-1.23l-.1-.18,0-.21-.29-.19a174.58,174.58,0,0,0-18.79-10.76c-19-9.42-50.62-20.9-93.26-22.15h-.31l-.18.23-.66.83-.86,1,1.41,0C152.18,123.59,183.68,135,202.62,144.4Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.9,140.13l.64.06v-2.14l-.65-.06a45.88,45.88,0,0,0-15.46,1.41l-.26.07-.11.25c-.16.34-.31.68-.46,1l-.55,1.31,1.38-.4A43.8,43.8,0,0,1,113.9,140.13Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.33,151.42a173.1,173.1,0,0,1,24.84,16.76L230,169.7l-.89-2.19c-.22-.55-.46-1.09-.7-1.62l-.07-.16-.14-.12a176.08,176.08,0,0,0-123.63-37.68l-.3,0-.15.24c-.19.29-.37.59-.55.89l.54.4h0l-.56-.36-.68,1.12,1.35-.11A173.59,173.59,0,0,1,203.33,151.42Zm-99.18-21.93Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.68,136c22.93,2.53,58,11.54,94.71,40.09l1.71,1.33-.74-2c-.13-.36-.27-.72-.41-1.09l-.12-.31,0-.22-.25-.19c-36.84-28.27-71.92-37.22-94.87-39.75a154.28,154.28,0,0,0-35.57.12l-.3,0-1.22,2.35,1.31-.17A151.79,151.79,0,0,1,136.68,136Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.94,218.93l-2-.84-.21.58a152.15,152.15,0,0,0-6.05,30v.1l0,.1c.19.9.4,1.8.62,2.7l.94,3.9.33-3.89a149.41,149.41,0,0,1,6.19-32.07Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.58,182.65V182l-2.16-.13,0,.65c.37,13.49-1.17,29.87-5,53.12v.19c.12,1,.26,2,.41,2.94l.61,4.07.66-4C90.27,214.1,92,196.76,91.58,182.65Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.45 212.12 100.22 203.44 98.15 202.64 95.4 211.32 97.45 212.12",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.92,177a20,20,0,0,1,5.31-11l.47-.43L96.14,164l-.44.41a21.62,21.62,0,0,0-5.92,12.17l-.07.62,2.14.45Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.77,194.66l2.16.26,0-.64c.2-5.83,6-14,6.29-14.32l.36-.5-1.77-1.34-.37.49C99.2,179,93,187.36,92.79,194Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.36,184.38l.46-.44-1.64-1.58-.43.46c-.77.83-7.63,8.51-11.27,24.24l-.14.61,2.11.65.14-.61C98.27,191.8,105.3,184.45,105.36,184.38Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.6 192.53 104.74 191.29 100.04 198.94 101.91 200.18 106.6 192.53",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.8,166.19l.59-.18-.8-2.06-.6.19c-.46.15-11.22,3.67-14.2,14.79l-.16.61,2.08.71.16-.6C97.59,169.53,107.38,166.33,107.8,166.19Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,152.13l.64-.09-.51-2.12-.62.09c-10.19,1.48-16,5.15-19.06,8l-.21.21,0,.18L90,162.82l1.9-2.06C94.2,158.23,99.79,153.76,111,152.13Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.71,144c22.87.89,57.87,8.69,94.79,40.81l1.73,1.5-.72-2.13c-.17-.49-.33-1-.51-1.46v-.21l-.23-.19c-37.1-31.85-72.25-39.58-95.2-40.46-23.53-.91-40.28,4.9-44.85,6.7l-.23.09-.09.23c-.12.3-.23.61-.33.91l-.59,1.66,1.41-.58C98,149.5,115,143,139.71,144Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.43,149.74c-26.13,1-43.73,11.58-44.48,12l-.54.32,1.27,1.84.53-.32c.72-.44,17.94-10.79,43.52-11.74,22.69-.86,57.52,5.67,94.56,41.65l1.7,1.65-.65-2.23c-.16-.54-.33-1.08-.5-1.61l-.05-.18-.14-.13C200.38,155.35,165.3,148.89,142.43,149.74Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.81,164.12a91.43,91.43,0,0,0-45.52-6.44c-25.9,3.07-42.84,16.81-43,16.95l-.46.39,1.44,1.69.47-.39a89,89,0,0,1,42-16.5c22.44-2.67,57,2.56,94,42.53l1.71,1.84-.63-2.37c-.16-.58-.31-1.15-.47-1.72l0-.17-.12-.12C224.43,183,207.8,171,190.81,164.12Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,164.4c-37-3.36-63,22.78-63.28,23l-.44.44,1.62,1.55.43-.43c.25-.26,25.67-25.75,61.66-22.47,24.84,2.26,49.07,17.28,72,44.64l1.74,2.07-.63-2.56c-.14-.58-.28-1.14-.41-1.72l0-.18-.14-.17C219.44,181.57,195,166.69,170,164.4Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,204.69c17.84-25.59,53.81-42.38,94-22.2,20.89,10.49,29.63,22.95,39.75,37.37q1.44,2.05,2.94,4.16l1.64,2.3-.49-2.7c-.12-.65-.23-1.29-.35-1.87v-.19l-.11-.15c-.64-.9-1.27-1.79-1.89-2.69-10.32-14.68-19.23-27.36-40.64-38.13-41.31-20.76-78.29-3.52-96.62,22.77-16.74,24-15.55,51.65-13.34,66l0,.14c.52,1.37,1,2.74,1.58,4.08l1.23-.26C90.75,248,95.24,223,108,204.69Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.64,273.43c-3.79-9.76-5.59-10.79-7-10.45-3.5.84-.26,13.57-.23,13.7,1.8,6.89,30.28,22.7,42.44,29.17l.55.3,1-1.82-.62-.33c-19.14-10.21-40-22.85-41.3-27.69-1.42-5.44-1.46-9.71-1.16-11,.55.61,1.89,2.58,4.27,8.71,5.67,14.61,27.53,23.11,40.06,26.87l.49.15.23-.43.41-.81.34-.7-.79-.24C222.16,295.17,200.88,286.93,195.64,273.43Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.55,270c-3.84-8.86-6.86-12.75-9.78-12.56s-5,4.48-6.44,14.08c-2,12.88,34.39,33.27,45.59,39.22l.5.27.3-.44c.17-.24.32-.49.47-.73l.36-.58-.65-.35C206.51,297,183.08,281,184.46,272c1.71-11.12,3.79-12.41,4.65-12.45.62,0,3,.8,7.47,11.11s17.54,19.43,38.81,26.71l.54.19.21-.49c.06-.13.12-.25.17-.37s.13-.26.19-.4l.29-.66-.73-.24C215.67,288.45,202.7,279.66,198.55,270Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.46,266.55c-4.85-10.16-9.32-15.12-13.72-15.16s-8.12,5-11.47,15.23c-6.08,18.58,35.51,42.1,48.4,48.86l.49.26,1.24-1.7-.71-.37c-8.9-4.7-53-29-47.37-46.23,3-9.1,6.3-13.91,9.64-13.91s7.27,4.82,11.56,13.81c4.76,10,17,18.63,37.41,26.49l.53.21.24-.48a8.41,8.41,0,0,0,.35-.82l.24-.62-.66-.25C217.76,284.22,205.93,275.93,201.46,266.55Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.36,263.12c-6.24-11.85-12.37-18-18.22-18.12S175,250.5,170.2,261.81s2.87,25.11,22.1,40a209,209,0,0,0,28.83,18.27l.47.24.3-.37.55-.66.48-.61-.74-.38c-10.05-5.25-59.68-32.57-50-55.49,4.44-10.51,9.17-15.77,14.07-15.64S196.67,253,202.47,264c6.6,12.53,23.65,21,35.91,26.25l.6.26.32-.83c.06-.18.13-.35.19-.53l.21-.58-.61-.26C227.17,283.16,210.61,275,204.36,263.12Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.26,259.68c-8.16-14.09-15.74-21-23.18-21.28-7.2-.21-13.89,6.06-20,18.64-3,6.28-3.19,13.09-.44,20.22,8.87,23.05,46.2,43.37,53.59,47.21l.44.22.31-.32.59-.64.55-.61-.79-.41c-7.29-3.77-44.08-23.71-52.69-46.07-2.52-6.54-2.39-12.78.4-18.54,5.63-11.65,11.64-17.55,17.88-17.55h.25c6.57.2,13.51,6.76,21.22,20.07,6.76,11.68,21.87,20,34.28,25.94l.62.29.23-.6c.1-.26.19-.53.28-.8l.19-.56-.57-.27C228.36,278.82,213.66,270.75,207.26,259.68Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.16,256.24C203,245,193.27,232,181.73,231.68h-.35c-8.32,0-16.18,6.93-23.36,20.61-4.18,8-4.64,16.49-1.37,25.31,9.52,25.72,48.63,47.07,56.37,51.09l.41.21.31-.28c.22-.2.44-.4.65-.61l.64-.61-.85-.44C206.54,323,168,302.15,158.66,277c-3-8.22-2.61-16.16,1.3-23.6,6.91-13.19,14.28-19.81,21.92-19.59,10.42.25,19.63,12.66,26.49,23.45,7,11,20.37,19.06,32.56,25.53l.66.35.22-.66c.09-.28.17-.56.25-.83l.13-.51-.49-.27C229.82,274.55,216.79,266.67,210.16,256.24Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.05,252.78l-.17-.24c-7.17-10.29-19.17-27.52-33.74-27.69h-.2c-9.59,0-18.68,7.63-27,22.68A35.54,35.54,0,0,0,149.51,278c9.78,27.26,47.51,48.75,58.84,54.69l.38.2.38-.3c.22-.17.44-.34.65-.52l.71-.61-.89-.46c-8-4.15-48.24-26.21-58.06-53.56a33.55,33.55,0,0,1,2.32-28.73c8-14.5,16.6-21.81,25.47-21.69,13.4.16,24.95,16.76,31.84,26.67l.17.24c7.26,10.43,20.24,18.86,30.73,25l.7.42.58-2.06-.47-.27C232.65,271,220,262.81,213.05,252.78Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216,249.36c-.36-.47-.74-1-1.13-1.51l-.95-1.25c-8-10.67-21.29-28.53-37.36-28.57-10.85,0-21.16,8.33-30.67,24.76-6.62,11.46-7.79,23.47-3.48,35.7,10.24,29.09,49.12,51.67,60.79,57.9l.35.18,2-1.31-1-.52c-11.56-6.1-50-28.23-60.09-56.79-4.09-11.62-3-23,3.34-34,9.13-15.8,18.88-23.8,29-23.8,14.87,0,27.75,17.29,35.45,27.6.74,1,1.44,1.93,2.09,2.78,7.61,10,19.38,18.28,28.78,24.38l.74.48.21-.8.21-.86.09-.45-.41-.27C234.77,267.1,223.33,259,216,249.36Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.67,247.22c-19.11-28.58-36.17-34.69-47.13-34.78-13-.05-24.32,8-32,22.9-9,17.56-10.22,34.8-3.52,51.23,11.59,28.4,43.75,46.74,57,53.3l.29.14.27-.12c.33-.15.65-.32,1-.49l1.07-.57-1.17-.58c-10.28-5-44.73-23.59-56.46-52.34-6.46-15.81-5.29-32.46,3.46-49.47,7.25-14.09,17.9-21.85,30-21.85h.22c10.4.08,26.67,6,45.21,33.71,5.68,8.5,15.84,16.19,23.36,21.14l.78.51.19-.94c.06-.27.11-.54.16-.8l.08-.43-.39-.26C237.86,262.73,228.09,255.31,222.67,247.22Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.28,242.64c-7.86-11.64-15.48-19.88-24-25.93-11.46-8.15-23.21-11.4-34-9.42-11.72,2.17-22,10.51-29.08,23.48-15.59,28.68-7.54,52.69,2,67.77,14.71,23.57,41.67,38.12,52.58,43.28l.27.12.25-.1c.36-.14.7-.28,1-.44l1.25-.56-1.32-.61c-10.85-5-37.67-19.3-52.29-42.7-9.18-14.58-17-37.8-1.84-65.62,6.77-12.46,16.62-20.45,27.74-22.51,10.16-1.88,21.32,1.24,32.26,9,8.25,5.86,15.68,13.9,23.38,25.3,4.44,6.58,11.69,13.63,21.55,21l.81.6.18-.93c.07-.31.12-.62.16-.94l.06-.4-.34-.25C236.47,255.69,229.51,248.92,225.28,242.64Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.89,238.07c-8.75-12.85-16.64-21-26.36-27.39-12.57-8.21-25.42-11.33-37.18-9-12.69,2.49-23.86,11.2-31.46,24.51-13,22.73-12.74,48.86.61,71.7,14.79,25.29,43,40.32,54.39,45.61l.23.1.22-.06c.38-.1.75-.22,1.12-.34l1.63-.53-1.55-.7c-11.4-5.17-39.5-19.91-54.19-45-7.61-13-17.8-39.36-.56-69.57,7.32-12.82,18-21.2,30.15-23.59,11.2-2.21,23.48.79,35.52,8.66,9.45,6.18,17.13,14.17,25.68,26.72,4.32,6.35,10.92,13.21,19.62,20.41l.87.72.15-1.06c.05-.33.09-.66.12-1l0-.35-.29-.24C238.34,250.73,232,244.14,227.89,238.07Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.5,233.49c-6.95-10.12-15.25-20.62-28.73-28.84-34.66-21.14-61.64-4.07-74.21,17-13.78,23.06-14,51.32-.74,75.61,14.06,25.68,40.67,40.82,55.28,47.57l.19.09.2,0c.48-.08,1-.16,1.44-.26l1.91-.37-1.86-.84c-14.64-6.61-41.3-21.5-55.29-47-12.94-23.6-12.66-51.08.74-73.5,12.09-20.25,38-36.7,71.34-16.39,13.07,8,21.18,18.24,28,28.14A115.71,115.71,0,0,0,246.25,254l.95.87.11-1.21c0-.35.05-.7.07-1l-.64-.11h0l.64.09,0-.32-.25-.23A113,113,0,0,1,230.5,233.49Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.11,228.91c-8.6-12.39-17.17-22.28-31.09-30.27-16-9.23-32.41-11.76-47.34-7.32-13,3.89-24.55,13-32.47,25.74-14.78,23.69-15.55,53.42-2.08,79.52,13.59,26.33,40,41.88,54.6,48.81l.14.06H175c.64,0,1.27,0,1.91,0l2.5-.14-2.36-1.08c-14.71-6.78-41.42-22.07-55-48.45-13.11-25.41-12.35-54.36,2-77.44,13.14-21.09,41.2-38.41,77-17.83,13.53,7.78,21.9,17.44,30.29,29.55a137.31,137.31,0,0,0,15.15,18l1,1.07,0-1.42c0-.39,0-.77,0-1.16v-.28l-.2-.2A135.37,135.37,0,0,1,233.11,228.91Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.72,224.34c-7.69-11-16.61-22.53-33.44-31.72-17.19-9.39-34.77-11.77-50.83-6.87-13.85,4.22-26.13,13.72-34.58,26.74-18.57,28.63-13.94,61.88-3.42,83.45,12,24.49,34.26,39.89,50.88,48.5l.16.08h.1c.85.16,1.73.29,2.62.4l3.63.46-3.36-1.67c-17.1-8.47-40-23.78-52.1-48.57-10.27-21-14.79-53.46,3.33-81.37,15.37-23.7,46.89-38.85,82.66-19.3,16.4,9,25.1,20.22,32.61,31a173.49,173.49,0,0,0,12.48,15.82l1.16,1.31-.05-1.84c0-.38,0-.76,0-1.17l0-.23-.16-.18A173.2,173.2,0,0,1,235.72,224.34Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.93,231.61l0-.19-.12-.16c-3.24-4.14-6.09-8.14-8.46-11.5-8.48-12-17.6-23.65-35.8-33.15-39.16-20.48-73.92-4.05-91,21.32-19.79,29.4-14.94,65.44-4.76,87.36,7.17,15.54,19.11,29.23,35.41,40.63l.18.13a69.19,69.19,0,0,0,7.37,3.83l.52-1.12c-19.54-12-33.52-26.86-41.54-44.22-9.94-21.41-14.69-56.6,4.64-85.31,16.58-24.64,50.32-40.61,88.32-20.75,17.7,9.26,26.63,20.61,34.94,32.4,2.41,3.44,5.66,8,9.34,12.63l1.31,1.67-.18-2Q247,232.38,246.93,231.61Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.55,99.27a17.92,17.92,0,0,0-4.13.08,255,255,0,0,0,25.23,7.46C176.54,103.82,164.61,99.7,159.55,99.27Z",
    style: {
      fill: "#99246A"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFingerprintBg);
export default __webpack_public_path__ + "static/media/fingerprint-bg.0a8d07556c636ee0f6ee73b0b2d732e4.svg";
export { ForwardRef as ReactComponent };